import React, { PropTypes } from 'react';

const ReferralFormSelect = (props) => {
  const { input, label, isRequired, entities, entityKey, meta: { touched, error } }  = props;
  const hasError = touched && error;

  return (
    <div>
      <label htmlFor={`${input.name}`}>
        {label}
        {isRequired && <span className="required"> *</span>}
      </label>
      <select
        {...input}
        className={hasError ? 'is-invalid-input' : ''}
        id={`${input.name}`}
      >
        <option disabled value></option>
        {entities.map(item =>
            <option value={item.id} key={item.id}>{item[entityKey]}</option>)
        }
      </select>
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormSelect.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  entities: PropTypes.array,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  entityKey: PropTypes.string
};

export default ReferralFormSelect;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormSelect/index.js
 **/